import { GridCol, GridRow, keyframes, mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'

export const Wrapper = styled(GridRow)`
  display: flex;
  width: 100%;
  ${mixins.media.min.desktop} {
    min-height: 400px;
  }
`

const zoomIn = keyframes`
  0% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`

export const AssetSection = styled(GridCol)`
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  ${mixins.media.min.tablet} {
    height: 400px;
  }
`

export const AssetWrapper = styled(Asset)`
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    animation: ${zoomIn} 2s ease-in-out;
    width: auto;
    display: block;
    margin: 0 auto;
  }
`

export const ContentSection = styled(GridCol)`
  width: 100%;
  background: ${mixins.colors.grayLight};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${mixins.padding(10, 10, 20)};
  height: 210px;
  ${mixins.media.min.tablet} {
    ${mixins.padding(20, 20, 20)};
    height: 300px;
  }
  ${mixins.media.min.desktop} {
    ${mixins.padding(40, 40, 40)};
    height: 400px;
  }
`

const slideUp = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
`

export const TextSection = styled.div`
  overflow: hidden;

  & > * {
    animation: ${slideUp} 1s ease-in-out;
  }
`

export const Title = styled.h4`
  ${mixins.typography.headlineMedium};
`

export const Description = styled.p`
  ${mixins.typography.paragraphMedium};
  display: none;
  ${mixins.media.min.tablet} {
    display: block;
  }
`

export const NavSection = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NavHeadline = styled.div`
  display: none;
  ${mixins.media.min.tablet} {
    display: block;
  }
`

export const NavButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`
